module.exports = __webpack_public_path__ + "static/media/residence-tag-icon.5bb0bf3d.svg";